<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.75 1.17 16.87 16.45"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.70215 14.6416C4.96604 15.011 5.26582 15.356 5.59837 15.6712C6.59782 16.6185 7.85037 17.2558 9.20447 17.5062C10.5586 17.7565 11.9562 17.6091 13.2283 17.0818C14.5004 16.5544 15.5924 15.6698 16.3722 14.5348C17.152 13.3998 17.5862 12.0632 17.6223 10.6866C17.6584 9.31004 17.2948 7.9525 16.5755 6.77824C15.8562 5.60397 14.8121 4.66331 13.5694 4.07005C12.8164 3.71057 12.01 3.48798 11.1877 3.4082L11.7566 5.53142C12.0827 5.6139 12.4013 5.72866 12.7077 5.87492C13.6016 6.30165 14.3527 6.97827 14.87 7.82292C15.3874 8.66756 15.649 9.64404 15.623 10.6342C15.597 11.6244 15.2847 12.5858 14.7238 13.4022C14.1629 14.2186 13.3774 14.8549 12.4624 15.2342C11.5474 15.6135 10.5421 15.7196 9.56806 15.5395C8.59406 15.3594 7.6931 14.901 6.9742 14.2196C6.92352 14.1716 6.87391 14.1226 6.82537 14.0727L4.70215 14.6416Z"
      fill="url(#paint0_linear_1_804)"
      class="fill"
    />
    <path
      d="M5.17334 3.55816C5.8199 3.06203 6.53128 2.65968 7.28627 2.36154C7.70033 2.19804 7.90736 2.11629 8.10748 2.21705C8.30759 2.31781 8.36978 2.5499 8.49415 3.01407L10.2412 9.53407C10.3632 9.98942 10.4242 10.2171 10.3206 10.3964C10.2171 10.5758 9.98942 10.6368 9.53407 10.7588L3.01408 12.5058C2.5499 12.6302 2.31781 12.6924 2.13049 12.5695C1.94317 12.4466 1.91046 12.2264 1.84503 11.7861C1.72572 10.9831 1.71848 10.1659 1.82486 9.3579C1.97484 8.21866 2.34774 7.12012 2.92228 6.125C3.49681 5.12988 4.26172 4.25767 5.17334 3.55816Z"
      stroke="url(#paint1_linear_1_804)"
      stroke-width="2"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_804"
        x1="11.1635"
        y1="3.4082"
        x2="11.1635"
        y2="17.6249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#666666" />
        <stop offset="1" stop-color="#666666" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_804"
        x1="10.5"
        y1="1.75"
        x2="10.5"
        y2="19.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#666666" />
        <stop offset="1" stop-color="#666666" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  max-width: 20px;
  max-height: 20px;
}
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
